// extracted by mini-css-extract-plugin
export default {"news-item":"BAdk76mhC_ixA4Qn6ExJ","news-pic":"zzyXVJtiz81scll3LUix","news-content":"IaRlocvlO86vPXqaRI5H","news-title":"Rgz6jvrXRyGCKxfYs6Pn","news-date":"h7vZyGl4gcEf1_mt0WMY"};